import { adminNavbarAppearanceShared } from "./adminNavbarAppearanceShared";

/** Tema 1 — üst bar sınıfları ve arama kutusu ölçüleri */
export const theme1NavbarAppearance = {
  ...adminNavbarAppearanceShared,
  navbarShellClassNames: {
    "admin-navbar-shell-theme-1": true,
    "admin-navbar-shell-theme-2": false,
  },
  navbarWrapperShellClassNames: {
    "navbar-wrapper-shell-theme-2": false,
  },
  sidebarToggleClassName: "navbar-toggler",
  searchTrigger: {
    ...adminNavbarAppearanceShared.searchTriggerFrame,
    padding: "8px 16px",
    maxWidth: "500px",
  },
};
